<template>
  <div>
    <vs-row>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12">
        <vs-table
          search
          pagination
          :data="leagues"
          :total="leagues && leagues.length"
          :max-items="25"
          description
          :description-items="[25, 50, 100]"
          description-title="Leagues"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <vs-row>
              <vs-col vs-w="3" vs-xs="12" vs-sm="12" style="margin: 5px 0;"
                ><h2 class="center">
                  All Leagues ({{ leagues.length }})
                </h2></vs-col
              >
              <vs-col vs-w="3" vs-xs="12" vs-sm="12" style="margin: 5px 0;"
                ><vs-button
                  style="margin: 0 auto;"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="leagueForm = true"
                  >Add New League</vs-button
                ></vs-col
              >
            </vs-row>
          </template>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="city">City</vs-th>
            <vs-th sort-key="state">State</vs-th>
            <vs-th sort-key="country">Country</vs-th>
            <vs-th sort-key="fee">Fee</vs-th>
            <vs-th sort-key="active">Active</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" v-for="(d, index) in data">
              <vs-td :data="d.name"
                ><router-link
                  :to="{ name: 'league-manager', params: { id: d.id } }"
                  >{{ d.name }}</router-link
                ></vs-td
              >
              <vs-td :data="d.city">{{ d.city }}</vs-td>
              <vs-td :data="d.state">{{ d.state }}</vs-td>
              <vs-td :data="d.country">{{ d.country }}</vs-td>
              <vs-td :data="d.fee">{{ d.fee }}</vs-td>
              <vs-td :data="d.active">{{ d.active }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <vs-popup
      title="Create League"
      :active.sync="leagueForm"
      background-color-popup="#FFF"
    >
      <div>
        <vs-input
          name="name"
          v-model="dataLeague.name"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="Name"
          class="w-full"
        />
      </div>
      <div>
        <vs-input
          name="city"
          v-model="dataLeague.city"
          icon-no-border
          icon="icon icon-map-pin"
          icon-pack="feather"
          label-placeholder="City"
          class="w-full"
        />
      </div>
      <div>
        <vs-input
          name="state"
          v-model="dataLeague.state"
          icon-no-border
          icon="icon icon-map-pin"
          icon-pack="feather"
          label-placeholder="State"
          class="w-full"
        />
      </div>
      <div>
        <vs-input
          name="country"
          v-model="dataLeague.country"
          icon-no-border
          icon="icon icon-map-pin"
          icon-pack="feather"
          label-placeholder="Country"
          class="w-full"
        />
      </div>
      <div>
        <vs-textarea
          name="description"
          v-model="dataLeague.description"
          icon-no-border
          icon="icon icon-article"
          icon-pack="feather"
          label="Description"
          class="w-full"
        />
      </div>
      <div style="margin: 10px 0 0">
        <vs-button @click="createNewLeague()">
          Create League
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import UserRoles from "@/mixins/UserRoles";
import { mapActions } from "vuex";
export default {
  name: "league-listing",
  created() {
    this.loadLeagues();
  },
  mixins: [UserRoles],
  data: () => ({
    leagues: [],
    leagueForm: false,
    leagueType: null,
    dataLeague: {
      name: "",
      city: "",
      state: "",
      country: "",
      description: ""
    },
    dataCourt: {
      name: ""
    },
    dataDivision: {
      name: ""
    }
  }),
  methods: {
    ...mapActions({
      getLeagues: "league/getLeagues",
      create: "league/createLeague"
    }),
    async loadLeagues() {
      this.$vs.loading();
      const { json } = await this.getLeagues();
      this.leagues = json;
      this.$vs.loading.close();
    },
    resetDataLeague() {
      this.dataLeague = {
        name: "",
        city: null,
        state: null,
        country: null,
        description: null
      };
    },
    resetDataCourt() {
      this.dataCourt = {
        name: ""
      };
    },
    resetDataDivision() {
      this.dataDivision = {
        name: ""
      };
    },
    async createNewLeague() {
      try {
        const { json } = await this.create({
          data: { ...this.dataLeague, created_by: this.user.id }
        });
        this.leagueForm = false;
        this.resetDataLeague();
        this.$toasted.success("Successfully Created League").goAway(2000);
        this.$router.push({
          name: "league-manager",
          params: { id: json[0].id }
        });
      } catch (ex) {
        console.log(ex);
        this.$toasted.error("Unable to Create League").goAway(2000);
        this.leagueForm = false;
        this.resetDataLeague();
      }
    },
    createNewCourt() {
      this.leagueForm = false;
      this.$router.push({ name: "league-maker", params: { id: 0 } });
    }
  }
};
</script>
